import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { whatsappUrl } from "../../constants/ContactUrl";

export default () => {
  const { t } = useTranslation();

  return (
    <div className="row card-deck justify-content-center d-sm-none">
      <div
        className="card mb-2 mx-1 px-0 table-responsive"
        style={{ boxShadow: "0px 10px 40px #9C9C9C" }}
      >
        <div className="card-body p-0">
          {/* TABLE FOR MOBILE */}
          <ul className="list-group text-center">
            <li className="list-group-item list-group-item-warning subheadline7">
              {t("COMMERCIAL.pricesTableMobileCol1CommercialMY")}
            </li>
            <li className="list-group-item">
              {t("COMMERCIAL.pricesTableMobileCol2CommercialMY")}
              <br />
              <br />
              <span>
                {t("COMMERCIAL.pricesTableMobileCol2_2CommercialMY")}
                <strong>{t("COMMERCIAL.pricesTableMobileCol2_3CommercialMY")}</strong>
                {t("COMMERCIAL.pricesTableMobileCol2_4CommercialMY")}
              </span>
              <br />
              <span>
                {t("COMMERCIAL.pricesTableMobileCol2_5CommercialMY")}
                <strong>{t("COMMERCIAL.pricesTableMobileCol2_6CommercialMY")}</strong>
                {t("COMMERCIAL.pricesTableMobileCol2_7CommercialMY")}
              </span>
              <br />
              <br />
              <span>{t("COMMERCIAL.pricesTableMobileCol2_8CommercialMY")}</span>
              <br />
              <br />
              {t("COMMERCIAL.pricesTableMobileCol2_9CommercialMY")}
              <br />
              <span>
                <a
                  className=""
                  href={whatsappUrl}
                  style={{
                    color: "#3b3a3b",
                    fontSize: 12,
                    fontFamily: "lato",
                  }}
                >
                  <img
                    src={require("../../images/whatsapp2.svg")}
                    style={{ width: 15, height: 15 }}
                  />
                  <strong className="strong3 pt-3">
                    {t("COMMERCIAL.pricesTableMobileCol2_10CommercialMY")}
                  </strong>
                </a>
              </span>
              <br />
              <br />
              {t("COMMERCIAL.pricesTableMobileCol2_11CommercialMY")}
            </li>
            <li className="list-group-item list-group-item-warning subheadline7">
              {t("COMMERCIAL.pricesTableMobileCol3CommercialMY")}
            </li>
            <li className="list-group-item">
              {t("COMMERCIAL.pricesTableMobileCol4CommercialMY")}
              <br />
              <br />
              {t("COMMERCIAL.pricesTableMobileCol4_2CommercialMY")}
              <br />
              <strong>{t("COMMERCIAL.pricesTableMobileCol4_3CommercialMY")}</strong>
              {t("COMMERCIAL.pricesTableMobileCol4_4CommercialMY")}
              <br />
              {t("COMMERCIAL.pricesTableMobileCol4_5CommercialMY")}
              <br />
              <span>
                <a
                  href={whatsappUrl}
                  style={{
                    color: "#3b3a3b",
                    fontSize: 12,
                    fontFamily: "lato",
                  }}
                >
                  <img
                    src={require("../../images/whatsapp2.svg")}
                    style={{ width: 15, height: 15 }}
                  />
                  <strong className="strong3 pt-3">
                    {t("COMMERCIAL.pricesTableMobileCol4_6CommercialMY")}
                  </strong>
                </a>
              </span>
              <br />
              <br />
              {t("COMMERCIAL.pricesTableMobileCol4_7CommercialMY")}
            </li>
            <li className="list-group-item list-group-item-warning subheadline7">
              {t("COMMERCIAL.pricesTableMobileCol5CommercialMY")}
            </li>
            <li className="list-group-item">
              {t("COMMERCIAL.pricesTableMobileCol6CommercialMY")}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
